import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Observable, Subject } from 'rxjs';
import {
  BaseAuthenticatedService,
  httpQueryParams,
  PaginatedResponse,
  RecursiveInterface,
} from './base-authenticated.service';
import { ReferralRequestInterface } from '@app/interface/referral-request';

@Injectable({
  providedIn: 'root',
})
export class ReferralRequestApi extends BaseAuthenticatedService {
  constructor(
    public override auth: AngularFireAuth,
    public override httpClient: HttpClient, // private cookieService: CookieService
  ) {
    super(auth, httpClient);
  }

  // using getRecursivePage
  public getAllReferralRequests<T = ReferralRequestInterface>(
    organization_id: number | null,
    params: httpQueryParams = {},
  ): Subject<RecursiveInterface<T>> {
    const path = `api/${organization_id}/referralrequest/`;
    return this.getRecursivePage<T>(path, params);
  }

  public createReferralRequest(
    organization_id: number,
    data: Partial<ReferralRequestInterface>,
  ): Observable<ReferralRequestInterface> {
    const path = `api/${organization_id}/referralrequest/`;
    return this.post<ReferralRequestInterface>(path, {}, data);
  }

  public updateReferralRequestDetails(
    organization_id: number | null,
    id: number,
    data: Partial<ReferralRequestInterface>,
  ): Observable<ReferralRequestInterface> {
    return this.partialUpdate<ReferralRequestInterface>(
      `api/${organization_id}/referralrequest/${id}/`,
      {}, //{ withCredentials: true },
      data,
    );
  }
}
